export class SupplierModel {
    supplierUid: string;
    supplierId: number;
    companyName: string;
    firstName: string;
    lastName: string;
    street: string;
    houseNumber: string;
    city: string;
    zipCode: string;
    companyLin: string;
    companyTin: string;
    email?: any;
    phoneNr?: any;
    active: boolean;
    businessType: number;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/supplier-dialog/supplier.model.ts